import { yupResolver } from '@hookform/resolvers/yup';

import CustomFilterBtn from '@Modules/core/components/form/CustomFilterBtn';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import { TFormUIProps } from '@Modules/core/types/FormUIPropsType';
import displayCustomInputs from '@Shared/utils/displayCustomInputs';
import React from 'react';
import { useForm } from 'react-hook-form';
import { IBatchesMonitoringFilterFormMeta, moduleEnum } from '../../containers/tableHandlers/batches/monitoring/BatchesMonitoringFilterFormMeta';

type Props = {
  meta: IBatchesMonitoringFilterFormMeta,
} & TFormUIProps;

const GimacBatchesMonitoringFormUI: React.FC<Props> = ({
  onSubmit,
  isLoading,
  isSubmitting,
  meta,
}) => {
  const {
    register,
    handleSubmit, watch,
    formState: { errors },
  } = useForm({ resolver: yupResolver(meta.schema) });

  const watchSelectedModule = watch("module", 'holderManagement') as string;

  return (
    <CC.Box as={'form'} onSubmit={handleSubmit(onSubmit)}>
      {displayCustomInputs<IBatchesMonitoringFilterFormMeta>(
        meta,
        register,
        errors,
        isLoading, [meta.module.name], []
      )}

      <CC.Heading size="sm" mt={"2rem"}>{moduleEnum[watchSelectedModule]} {watchSelectedModule && ':'} </CC.Heading>

      <CC.SimpleGrid columns={{ base: 1, md: 2 }} spacing={10} mt={8}>
        {displayCustomInputs<IBatchesMonitoringFilterFormMeta>(
          meta,
          register,
          errors,
          isLoading, [], [meta.module.name]
        )}
      </CC.SimpleGrid>

      <CC.HStack my={4} justifyContent={'flex-end'}>
        <CustomFilterBtn isLoading={isLoading} isSubmitting={isSubmitting} />
      </CC.HStack>
    </CC.Box>
  );
};

export default GimacBatchesMonitoringFormUI;
